import { DrawCabinet } from "$src/CGS/domain/dto/article/Cabinet/DrawCabinet";
import DrawS1CabinetShape from "$src/CGS/domain/dto/article/shape/CabinetShapes/DrawS1CabinetShape";
import { Vector3 } from "three";
import { BaseCabinetShapeGenerator } from "./BaseCabinetShapeGenerator";
import { ICabinetShapeGeneratorParameters } from "./ICabinetShapeGeneratorParameters";
import { CabinetBoxFace } from "./CabinetBoxFace";
import { EFaceElements } from "../../Meshes/EFaceElements";
import { EMaterialSlot } from "../../Meshes/EMaterialSlot";
import { LengthMaths } from "$src/CGS/domain/dto/core/Length/LengthMaths";

export class CabinetS1ShapeGenerator extends BaseCabinetShapeGenerator<DrawS1CabinetShape> {
   
    constructor(cabinet: DrawCabinet, parameters: ICabinetShapeGeneratorParameters | null) {
        super(cabinet, parameters);
    }

    protected getAnchorOffset(): Vector3 {
        return new Vector3();
    }

    public override getOutline(): Vector3[] {

        return [
            new Vector3(0, 0, 0),
            new Vector3(LengthMaths.getLengthValue(this.data.Width).meter, 0, 0),
            new Vector3(LengthMaths.getLengthValue(this.data.Width).meter, 0, LengthMaths.getLengthValue(this.data.Depth).meter),
            new Vector3(0, 0, LengthMaths.getLengthValue(this.data.Depth).meter)
        ];
    }
    
    public getDefaultFaceDescription(): CabinetBoxFace[] {
        return [
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.Box, 2),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.SideLeft, 3),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.Box, 0),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.SideRight, 1),
        ];
    }
    
}
